export const costs = [
  'Sleepless nights searching for ways to translate complex geological processes into language your students can understand',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time",
  "Disconnected students who don't see how geology connects to natural resources, hazards, or their communities",
  "Awkward silences when a student asks how fossils form or why mountains exist and you don't have a clear answer",
  'Weekends lost building lesson plans, geological mapping projects, and assessments from scratch over and over',
  'Uncertainty about how to teach structural geology, paleontology, or geomorphology without adequate resources',
];
